"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    generalConstants: {
        ariaLabel: {
            fetchingAssignmentsData: 'Fetching assignments',
            fetchingAssessmentsReports: 'Fetching assessments reports data',
            fetchingSchools: 'Fetching schools data',
            fetchingClasses: 'Fetching classes data',
            fetchingReports: 'Fetching reports data',
        },
        bandLegend: {
            highlyProficient: 'Highly Proficient',
            proficient: 'Proficient',
            partial: 'Partially Proficient',
            notYet: 'Not Yet Proficient',
        },
    },
};
